export default "__VITE_ASSET__7ab3a41d__"